// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const environment = {
  Cognito: {
    userPoolId: '',
    userPoolClientId: '',
    userPoolWebClientId: '',
    identityPoolId: '',
    loginWith: {
      email: true,
    },
    signUpVerificationMethod: 'code',
    userAttributes: {
      email: {
        required: true,
      },
    },
    allowGuestAccess: false,
    passwordFormat: {
      minLength: 8,
      requireLowercase: true,
      requireUppercase: true,
      requireNumbers: true,
      requireSpecialCharacters: true,
    },
  },
  backendUrl: 'api.public.dev.grsp.cimbaligroup.tech',
  webrtcUrl: 'service.dev.grsp.cimbaligroup.tech',
  jwtToken: 'eyJhbGciOiJSU0EtT0FFUC0yNTYiLCJlbmMiOiJBMjU2R0NNIn0.PP_Y6gClK4sE3YRjcuJdWDbEnSYMb_khP82bED0rjdgYOIxE1rGlW7pwOhJilzYkz6HCrmKgH1JyaR2-sfb2CuqfJ-zSNp8iYoMGCFsbzIiyAVpYLapZXobFubzOBwMqliQEB7OpetXy3wzoPa9MPGRH-QnKuy5r-3SxpC-gxIF6I5gksPotjLIAZuj7J1TGDJ-c1opaOIM7T7_sYHN_GvxqQ5sFS9wqG8XTIHBYHrcmGloDfR64Husr2THCtHgW7xLkcPqQNdsw-9Tf5vusS7mBY7wGbbLZNHz9x7y3cVJ7TMExsVA-Gao6pwwzHFS-Dv3Q6SJRW6nppcVxIbZ7kg.yedoKMcVMlLNpiZ_.Q4J4BeJmGNqdKO_7M9Ik-JXOH0xwiZU3M8x9HBaUyrlVi-QP_sfK3fTo90dgX1IzqPaFyrc88PRfvGMYs0nyBd9nHAc0n8N-Ly5GDiqLd9_2baf_J4p2P14TPUZbIzddjIPng-RH1MIiUV7Ufoq_2Q8eYRtdUsotNVBz5jaFuUU4ekPEIRgMPVqq5iZAPRDKfFG3ekZvditYAbPOWsociWsPDGmz_tdYimxeQw647S-x5QegJrub5re2EWka6FEiO8-9Bl8qGIn5E4aAF4MzQZC-yn8lwNbvjiwJLUqxYyCVuAHmGOdCnuiADdbwS-vCdOMqfHwOQEmNOc5gHasFgQvPEZrmjzMi09eyVxMbcQdV3Keb8DWb12Zc5yJPiJgZW8kP7OKqatGMlT49yOSeEbFtQTVlUSyJz3D3MkKo_1DsNXzsfLMMoCu5V5GKyYbDnZeKxjOh2mhjSefVDk5cLz_i4SLb435OOxjm1XXnnwCpo_dOupUTQx5bliN6CdXSh0P7MCt9-6zr4dZdPIEX_Ul4hMKoXGD0PDBCu0fzoMxRoNsLxFFdA-2cwrFjr_7lyxG0I63yLiLskgqKTGjdBLcvJY0tUnvdGj133Dbiyg8Zwd3jWcUKlFFZTbX9XOGfoiatKCEqxvhvNBaK9N0Tpe-cVP1hWv00HgyZciLq1DZU22gvDZkttXPz3LwDyqPpKgKClCeda-szBLtBJFv7ZMiKSB9ocHDlwWIZc56s5SbOvhTExDuOnCFasAoQ9zwgq_GFH-lS5l4WjB1HyH_qunGU7MKWTbHBrr2lQyZ5ut0aVxMoNZuxtw.oO-yz7qRpYv0U0Qhzk9MKQ',
  vapidPublicKey: 'BC5x22jTSdU3OYoZPsNrEfcu_-AXWwFvmpi6W5rbcd8E4MVfGwuOOgV2crYTRW92l7aLZGBiJ_I8KlyOnuwggEU',
};

export { environment };
